import React from 'react';

const ResultTitle = ({ questions, id }) => {
	const titleCard = questions[id].title;
	return <h4>{titleCard}</h4>
};

export default ResultTitle;




// WEBPACK FOOTER //
// ./src/components/ResultTitle/ResultTitle.js